import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const projectSettingsSoftwareNotificationEmailCRoute: InvariantJiraRoute = {
	name: 'project-settings-software-notifications-notification-email',
	path: '/jira/software/c/projects/:projectKey/settings/notifications/notification-email',
	exact: true,
};
